import * as fetchBookingReservations from 'store/actions/bookingReservations/fetchBookingReservations';
import * as types from 'store/actions/types';
import apiClient from 'clients/apiClient';
import config from 'helpers/config';
import { put, takeEvery } from 'redux-saga/effects';
import { showNotification } from 'store/actions/uiActions';

function* fetchBookingReservationsAsync({ payload }) {
    try {
        const { id } = payload;

        const url = `${ config.getApiBaseUrl() }/bookings/${ id }/booking-reservations`;

        const response = yield apiClient.read(url, payload);

        yield put(fetchBookingReservations.fetchBookingReservationsSuccess(id, response));
    } catch (error) {
        yield put(fetchBookingReservations.fetchBookingReservationsFailure(error));
    }
}

function* failureMessage({ error }) {
    const { message } = error.response;

    yield put(showNotification(message, 'warning'));
}

export default function* bookingReservationsSagas() {
    yield [
        takeEvery(types.FETCH_BOOKING_RESERVATIONS, fetchBookingReservationsAsync),
        takeEvery(types.FETCH_BOOKING_RESERVATIONS_FAILURE, failureMessage),
    ];
}



// WEBPACK FOOTER //
// ./src/store/sagas/bookings/bookingReservationsSagas.js